export const endpoints = {
  loadOperationsList: 'experienceTransfer/criteria/operation/options',
  updateOperations: 'experienceTransfer/criteria/operation'
};
